{
  "loading": "Įkeliama...",
  "placeholder": "Pasirinkite parinktį..."
}
